import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import { useContext } from "react";
import { ColorModeContext } from "../context/ColorModeContext";
import { TOP_BAR_HEIGHT } from "../constants/appConstants";

import {
    AppBar,
    Toolbar,
    Typography,
    IconButton,
} from "@mui/material";

// asset for background image
//import toppicture from "../assets/toppicture_winter.jpg";
import MenuIcon from "@mui/icons-material/Menu";

interface Props {
    title: string;
    onMenuClick?: () => void;
    showMenuButton?: boolean;
}

const TopBar: React.FC<Props> = ({
    title,
    onMenuClick,
    showMenuButton = false,
}) => {
    const { toggleColorMode, mode } = useContext(ColorModeContext);

    return (
        <AppBar
            position="fixed"
            sx={{
                height: TOP_BAR_HEIGHT,
                //backgroundImage: `url(${toppicture})`,
                backgroundPosition: "left top",
                backgroundRepeat: "no-repeat",
                backgroundSize: "auto",
            }}
        >
            <Toolbar sx={{ height: '100%', display: 'flex', alignItems: 'center' }}>
                {showMenuButton && (
                    <IconButton
                        color="inherit"
                        edge="start"
                        onClick={onMenuClick}
                        sx={{ mr: 2 }}
                    >
                        <MenuIcon />
                    </IconButton>
                )}
                <Typography variant="h3" noWrap sx={{ alignSelf: 'center', fontWeight: 'bold' }}>
                    {title}
                </Typography>

                <IconButton color="inherit" onClick={toggleColorMode} sx={{ ml: 'auto' }}>
                    {mode === "dark" ? <Brightness7Icon /> : <Brightness4Icon />}
                </IconButton>
            </Toolbar>
        </AppBar>
    );
};

export default TopBar;